/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { FormElement } from "../FormElement";
import { FormModel } from "../FormModel";
import { IFormFieldBaseConfig, FormFieldBase } from "./FormFieldBase";
import { FORM_EL_TYPE } from "../FormElementTypes";

/**
 * Element config
 */
export interface IFormFieldTextConfig extends IFormFieldBaseConfig<string> {
	placeholder?: string;
	suffix?: string;
	pattern?: RegExp;
	rows?: number;
	align?: "left"|"center"|"right";
	printFormatter?: (value: string) => string;
}

/**
 * Field Text
 */
export class FormFieldText extends FormFieldBase<IFormFieldTextConfig> {

	/**
	 * Element constructor
	 *
	 * @param model Model instance
	 * @param parent Parent element
	 * @param config Element configuration
	 */
	public constructor(
		protected model: FormModel,
		protected parent: FormElement<any>,
		protected config: IFormFieldTextConfig
	) {

		super(model, parent, FORM_EL_TYPE.FIELD_TEXT, config, "");

	}

	/**
	 * Validates the value - should be overriden
	 */
	protected validate() {

		let valid = true;
		const _value = String(this.value || "");

		if (this.config.pattern && _value !== "" && !_value.match(this.config.pattern)) {
			valid = false;
		}

		this.valid = valid;

	}

}

/**
 * Declares textual field
 *
 * @param config Config
 */
export function FieldText(
	config: IFormFieldTextConfig
) {

	return (model, parent) => new FormFieldText(model, parent, config);

}
